import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6271ccd2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6271ccd2')) {
      api.createRecord('6271ccd2', component.options)
    } else {
      api.reload('6271ccd2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6271ccd2", function () {
      api.rerender('6271ccd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/link/index.vue"
export default component.exports